import React from 'react';
import styles from './ApplicationRequirementsContainer.module.scss';

export interface Props {
  children: React.ReactNode;
}

const ApplicationRequirementsContainer = ({ children }: Props) => {
  return (
    <ol
      className={styles.container}
      data-testid="application-requirements-container"
    >
      {children}
    </ol>
  );
};

export default ApplicationRequirementsContainer;
